import { H } from 'highlight.run'
import { useCallback } from 'react'

import { getUniqueId } from '@/utils'

import { isHighlightEnabled } from './constants'

type Metadata = {
  [key: string]: string | boolean | number
}

export function useHighlight() {
  const identify = useCallback((identifier: string, metadata: Metadata) => {
    H.identify(identifier, metadata)
  }, [])

  const reset = useCallback(() => {
    H.identify('UNKNOWN_USER', {
      id: getUniqueId(),
    })
  }, [])

  return isHighlightEnabled ? { identify, reset } : null
}
